import dayjs from 'dayjs';

/** sessionStorage key: the booking page leaves a success message for My Appointments to show. */
export const BOOKING_FLASH_KEY = 'patient_booking_flash_message';

/** "14:30" → "2:30 PM" — patients read 12-hour times. */
export const to12h = (hhmm: string) => dayjs(`2000-01-01T${hhmm}`).format('h:mm A');
